module.exports = __webpack_public_path__ + "img/album15_03.1b52e613.jpg";